import { useMemo } from "react";
import { formatTime } from "../utils/formatTime.js";
function useOptions(optionValues, timeFormat) {
  return useMemo(
    () => optionValues.map((value) => ({
      label: formatTime(value, timeFormat),
      value
    })),
    [optionValues, timeFormat]
  );
}
export {
  useOptions
};
//# sourceMappingURL=useOptions.js.map
